import { largeTabletMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import styled, { css } from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const Container = styled.nav`
  width: 100%;
  height: 57px;
  border-bottom: ${({ theme }) => platform.select('none', `1px solid ${theme.keyline}`)};

  @media print {
    display: none;
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px;
  height: 57px;
  margin: 0 auto;
  max-width: ${MAX_WIDTH - 20}px;

  @media (${largeTabletMax}) {
    padding: 10px;
  }
`;

export const ProfilePlaceholder = styled.div`
  width: 100px;
  height: 100%;
  display: flex;
  justify-content: flex-end;

  @media (${mobileXXLargeMax}) {
    width: ${platform.select('100px', '45px')};
  }
`;

export const LogoLink = styled(Link)`
  flex: 1;
  max-width: 200px;
  display: block;
`;

export const PNLogoImg = styled.img`
  width: 100%;
  max-width: 200px;
  height: auto;
  display: block;
`;

export const LinksContainer = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  list-style: none;
  padding: 0;
  justify-content: center;
  flex: 1;

  li:last-child a {
    border-bottom: none;
  }

  @media screen and (${largeTabletMax}) {
    display: none;
  }
`;

export const LinkBox = styled(Link)<{ $active?: boolean }>`
  padding: 16px;
  cursor: pointer;
  display: inline-block;
  width: 100%;
  color: ${({ theme, $active }) => ($active ? theme.primary : theme.textDark)};
  font-weight: bold;

  &:hover {
    color: ${(props) => props.theme.primary};
  }
`;

export const SubLink = styled(Link)<{ $active?: boolean }>`
  padding: 16px;
  cursor: pointer;
  display: block;
  width: 100%;
  color: ${({ theme, $active }) => ($active ? theme.primary : theme.textDark)};
  font-weight: bold;
  border-bottom: 1px solid ${({ theme }) => theme.backgroundLight};

  &:hover {
    background-color: ${({ theme }) => theme.backgroundLightest};
    color: ${(props) => props.theme.primary};
  }
`;

export const LinkButton = styled.button<{ $active?: boolean }>`
  background: none;
  border: none;
  padding: 16px;
  cursor: pointer;
  display: inline-block;
  height: 100%;
  font-size: 16px;
  color: ${({ theme, $active }) => ($active ? theme.primary : theme.textDark)};
  font-weight: bold;

  &:hover {
    color: ${(props) => props.theme.primary};
  }

  ${(props) =>
    props.$active &&
    css`
      & + ul {
        display: flex;
        flex-direction: column;
      }
    `}
`;

export const ComponentBox = styled.ul`
  flex-direction: column;
  position: absolute;
  padding: 0;
  list-style: none;
  min-width: 200px;
  background-color: ${(props) => props.theme.white};
  z-index: 10;
  border-radius: 0 6px 6px 6px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  display: none;

  li {
    border-bottom: ${(props) => platform.select(`1px solid ${props.theme.textLight}`, 'none')};
  }

  li:last-of-type {
    border-bottom: none;
  }

  ${platform.type === 'propertynews' &&
  css`
    margin-top: -2px;
    border-radius: 6px;

    ${LinkBox} {
      font-weight: normal;
      padding: 20px 16px 0;
    }

    li:last-child ${LinkBox} {
      padding: 20px;
    }
  `}
`;

export const Hamburger = styled.div`
  display: none;
  align-items: center;
  justify-content: flex-start;
  margin-right: 15px;

  button {
    padding: 0 15px;

    svg {
      display: block !important;
    }
  }

  @media screen and (${largeTabletMax}) {
    display: flex;
  }
`;

export const SideMenu = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  background-color: ${({ theme }) => theme.background};
  width: 272px;
  overflow-y: auto;
  z-index: 10;
  height: 100vh;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  padding: 60px 30px 30px;
  color: ${({ theme }) => theme.textDark};

  h3 {
    margin-bottom: 15px;
    font-size: 21px;

    a:hover {
      color: ${({ theme }) => theme.primary};
    }
  }

  h4 {
    font-weight: normal;
    margin-bottom: 15px;

    a:hover {
      color: ${({ theme }) => theme.primary};
    }
  }

  p {
    font-size: 12px;
    margin-bottom: 15px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  padding: 10px;
  top: 10px;
  right: 10px;
`;
